import { CellCoordinateReference } from "./tiles.interfaces";
import { TileSystemBounds } from "./tiles.system";
import { PropertyChangedEventArgs } from "../events";
import { Cartesian2 } from "../geometry";
import { Geo2 } from "../geography";
export class AbstractTileMetrics extends TileSystemBounds {
    constructor(options) {
        super(options);
        this._tileSize = AbstractTileMetrics.DefaultTileSize;
        this._cellSize = AbstractTileMetrics.DefaultCellSize;
        this._cellCoordinateReference = AbstractTileMetrics.DefaultCoordinateReference;
        this._overlap = AbstractTileMetrics.DefaultOverlap;
    }
    mapSize(levelOfDetail) {
        const result = this.tileSize * Math.pow(2, levelOfDetail);
        return result >>> 0;
    }
    get tileSize() {
        return this._tileSize;
    }
    set tileSize(v) {
        if (this._tileSize !== v) {
            const old = this._tileSize;
            this._tileSize = v;
            this._propertyChangedObservable?.notifyObservers(new PropertyChangedEventArgs(this, old, v, "tileSize"), -1, this, this);
        }
    }
    get cellSize() {
        return this._cellSize;
    }
    set cellSize(v) {
        if (this._cellSize !== v) {
            const old = this._cellSize;
            this._cellSize = v;
            this._propertyChangedObservable?.notifyObservers(new PropertyChangedEventArgs(this, old, v, "cellSize"), -1, this, this);
        }
    }
    get cellCoordinateReference() {
        return this._cellCoordinateReference;
    }
    set cellCoordinateReference(v) {
        if (this._cellCoordinateReference !== v) {
            const old = this._cellCoordinateReference;
            this._cellCoordinateReference = v;
            this._propertyChangedObservable?.notifyObservers(new PropertyChangedEventArgs(this, old, v, "cellCoordinateReference"), -1, this, this);
        }
    }
    get overlap() {
        return this._overlap;
    }
    set overlap(v) {
        if (this._overlap !== v) {
            const old = this._overlap;
            this._overlap = v;
            this._propertyChangedObservable?.notifyObservers(new PropertyChangedEventArgs(this, old, v, "overlap"), -1, this, this);
        }
    }
    mapScale(latitude, levelOfDetail, pixelPerUnit) {
        if (pixelPerUnit === 0)
            return Infinity;
        const d = this.groundResolution(latitude, levelOfDetail);
        if (d === 0)
            return Infinity;
        return 1 / (d * pixelPerUnit);
    }
    getLatLonToTileXY(latitude, longitude, levelOfDetail) {
        const c = Cartesian2.Zero();
        this.getLatLonToTileXYToRef(latitude, longitude, levelOfDetail, c);
        return c;
    }
    getTileXYToLatLon(x, y, levelOfDetail) {
        const g = Geo2.Zero();
        this.getTileXYToLatLonToRef(x, y, levelOfDetail, g);
        return g;
    }
    getLatLonToPointXY(latitude, longitude, levelOfDetail) {
        const c = Cartesian2.Zero();
        this.getLatLonToPointXYToRef(latitude, longitude, levelOfDetail, c);
        return c;
    }
    getPointXYToLatLon(x, y, levelOfDetail) {
        const g = Geo2.Zero();
        this.getPointXYToLatLonToRef(x, y, levelOfDetail, g);
        return g;
    }
    getTileXYToPointXY(x, y) {
        const c = Cartesian2.Zero();
        this.getTileXYToPointXYToRef(x, y, c);
        return c;
    }
    getPointXYToTileXY(x, y) {
        const c = Cartesian2.Zero();
        this.getPointXYToTileXYToRef(x, y, c);
        return c;
    }
}
AbstractTileMetrics.DefaultTileSize = 256;
AbstractTileMetrics.DefaultCellSize = 1;
AbstractTileMetrics.DefaultCoordinateReference = CellCoordinateReference.CENTER;
AbstractTileMetrics.DefaultOverlap = 0;
//# sourceMappingURL=tiles.metrics.js.map